import { CardActions, DialogContent } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import styled from 'styled-components';

export const StyledPaymentContent = styled(DialogContent)`
  & .MuiStepper-root {
    padding-left: 0px;
    padding-right: 0px;
  }

  & .MuiStepLabel-root {
    padding: ${props => props.theme.spacing(1)};
    background-color: ${props => props.theme.palette.grey[50]};
    border: 1px solid ${props => props.theme.palette.grey[300]};
    border-radius: 3px;
  }

  & .MuiStepLabel-label {
    text-transform: uppercase;
  }

  & .MuiStepIcon-completed {
    color: ${props => props.theme.palette.secondary.main};
  }

  ${props => props.theme.breakpoints.down('sm')} {
    padding: ${props => props.theme.spacing(1)};

    & .MuiStepContent-root {
      border-left: transparent;
      margin-left: 0px;
      padding-left: ${props => props.theme.spacing(1)};
      padding-right: ${props => props.theme.spacing(1)};
    }
  }
`;

export const StyledCardActions = styled(CardActions)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & button {
    min-width: 8rem;
  }

  &.centered {
    justify-content: center;
  }
`;

export const StyledCardContent = styled(CardContent)``;

export const TimelineItemSpacer = styled.div`
  height: 16px;
  margin-left: ${props => props.theme.spacing(2.25)};

  &.enabled {
    border-left: 4px solid ${props => props.theme.palette.success.main};
  }

  &.disabled {
    border-left: 4px solid ${props => props.theme.palette.grey[300]};
  }
`;

export const TimelineWrapper = styled.div`
  &:last-child {
    ${TimelineItemSpacer} {
      border-left: 0px solid transparent;
    }
  }
`;

export const TimelineItem = styled.div`
  display: flex;
  align-items: center;

  &.enabled {
  }

  &.disabled {
    color: ${props => props.theme.palette.grey[500]};
  }

  & .icon {
    font-size: ${props => props.theme.spacing(5)};
    margin-right: ${props => props.theme.spacing(2)};
  }

  & .enabled {
    color: ${props => props.theme.palette.success.main};
  }

  & .disabled {
    color: ${props => props.theme.palette.grey[300]};
  }
`;
